/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {AppHeader} from "../ui/AppHeader";
import {LeftPanel} from "../ui/LeftPanel";
import {RoutingModule} from "@intuitionrobotics/thunderstorm/frontend";
import {Route_Admin, Route_Alerts, Route_Base, Route_CheckIn, Route_Messages, Route_Patients, Route_PatientsHome} from "../../Routes";
import {extractTabPermissions, getUserTokenInfo, isAdmin} from "@modules/utils";
import {TabPermissions} from "@app/app-shared/permission";
import {NoPermissionsPanel} from "./NoPermissionsPanel";

export const RenderHome = () => {

    const routes = []

    const userTokenInfo = getUserTokenInfo();
    const tabPermissions = extractTabPermissions(userTokenInfo);
    if (tabPermissions === TabPermissions.MESSAGES || tabPermissions === TabPermissions.CLINICAL_MESSAGES)
        routes.push(Route_Messages);

    if (isAdmin(userTokenInfo))
        routes.push(Route_Admin)

    routes.push(Route_PatientsHome);

    if (tabPermissions === TabPermissions.CLINICAL || tabPermissions === TabPermissions.CLINICAL_MESSAGES)
        routes.push(Route_Patients, Route_Alerts, Route_CheckIn)

    if (routes.length === 0)
        return <NoPermissionsPanel/>

    routes.push(Route_Base);
    return <div className="ll_v_s fill" style={{overflow: "hidden"}}>
        <AppHeader/>
        <div className={"ll_h_s fill"} style={{overflow: "hidden"}}>
            <LeftPanel/>
            <div style={{display: "flex", flex: 1, backgroundColor: "#f4f7f7", overflow: "hidden"}}>
                {RoutingModule.getRoutesMap(routes)}
            </div>
        </div>
    </div>;
}
